// Single source of truth for product categories across the app
export const CATEGORIES = [
  { name: 'Anime', image: '/anime-cover.jpg' },
  { name: 'Music', image: '/music-cover.jpg' },
  { name: 'Bikes', image: '/bikes-cover.jpg' },
  { name: 'Cars', image: '/cars-cover.jpg' },
  { name: 'Fighter Jets', image: '/fighter-jets-cover.jpg' },
  { name: 'Girly', image: '/girly-cover.jpg' },
  { name: 'Athletes', image: '/athletes-cover.jpg' },
  { name: 'Gods', image: '/gods-cover.jpg' },
  { name: 'Aesthetic', image: '/aesthetic-cover.jpg' },
  { name: 'Motivational', image: '/motivational-cover.jpg' },
  { name: 'Split Posters', image: '/split-posters-cover.jpg' },
  { name: 'Laptop Stickers', image: '/laptop-stickers-cover.jpg' },
];

export const CATEGORY_NAMES = CATEGORIES.map((c) => c.name);

// Default sizes/prices per category (anything not listed uses the standard prices)
const STANDARD_SIZES = [
  { label: 'A4', price: 69 },
  { label: 'A3', price: 79 },
];
const CATEGORY_SIZES = {
  'Split Posters': [
    { label: 'A4', price: 199 },
    { label: 'A3', price: 249 },
  ],
};
export const defaultSizesFor = (category) =>
  (CATEGORY_SIZES[category] || STANDARD_SIZES).map((s) => ({ ...s }));
